import { EnemyType } from '../constants';

export interface EnemyArchetype {
  readonly type: EnemyType;
  readonly name: string;
  readonly hp: number;
  readonly radius: number;
  readonly speed: number;
  readonly score: number;
  readonly lux: number;
  readonly sprite: string;
}

export const ENEMY_ARCHETYPES: readonly EnemyArchetype[] = Object.freeze([
  Object.freeze({ type: EnemyType.Threadling, name: 'THREADLING', hp: 6, radius: 6, speed: 1.35, score: 120, lux: 4, sprite: 'threadling' }),
  Object.freeze({ type: EnemyType.PlateFin, name: 'PLATE FIN', hp: 18, radius: 8, speed: 0.85, score: 260, lux: 7, sprite: 'plate_fin' }),
  Object.freeze({ type: EnemyType.Indexer, name: 'INDEXER', hp: 14, radius: 7, speed: 0.72, score: 300, lux: 8, sprite: 'indexer' }),
  Object.freeze({ type: EnemyType.ShadePolyp, name: 'SHADE POLYP', hp: 12, radius: 7, speed: 0.68, score: 280, lux: 7, sprite: 'shade_polyp' }),
  Object.freeze({ type: EnemyType.MirrorWisp, name: 'MIRROR WISP', hp: 11, radius: 7, speed: 0.95, score: 340, lux: 9, sprite: 'mirror_wisp' }),
  Object.freeze({ type: EnemyType.LockBeetle, name: 'LOCK BEETLE', hp: 20, radius: 8, speed: 0.62, score: 420, lux: 11, sprite: 'lock_beetle' }),
  Object.freeze({ type: EnemyType.FoldRay, name: 'FOLD RAY', hp: 24, radius: 9, speed: 0.5, score: 500, lux: 12, sprite: 'fold_ray' }),
  Object.freeze({ type: EnemyType.ArchiveRam, name: 'ARCHIVE RAM', hp: 34, radius: 11, speed: 0.55, score: 650, lux: 15, sprite: 'archive_ram' }),
  Object.freeze({ type: EnemyType.ChoirEngine, name: 'CHOIR ENGINE', hp: 70, radius: 14, speed: 0.5, score: 1300, lux: 28, sprite: 'choir_engine' }),
  Object.freeze({ type: EnemyType.PrismEater, name: 'PRISM EATER', hp: 78, radius: 14, speed: 0.6, score: 1500, lux: 30, sprite: 'prism_eater' }),
]);

export function getEnemyArchetype(type: EnemyType): EnemyArchetype {
  return ENEMY_ARCHETYPES[type] ?? ENEMY_ARCHETYPES[EnemyType.Threadling]!;
}
